let sharedCtx = null;

export function unlockAttendanceAudio() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return Promise.resolve();
    if (!sharedCtx) sharedCtx = new Ctx();
    if (sharedCtx.state === "suspended") return sharedCtx.resume();
    return Promise.resolve();
  } catch {
    return Promise.resolve();
  }
}

/** Sonido de confirmación (requiere desbloqueo previo con unlockAttendanceAudio). */
export async function playAttendanceSuccessSound() {
  try {
    await unlockAttendanceAudio();
    if (!sharedCtx) return;
    const ctx = sharedCtx;
    const playTone = (freq, start, duration, volume = 0.4) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(volume, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + duration);
    };
    const t0 = ctx.currentTime;
    playTone(523.25, t0, 0.2);
    playTone(659.25, t0 + 0.22, 0.35);
    playTone(783.99, t0 + 0.48, 0.4);
  } catch {
    /* sin audio */
  }
}

/** Alarma de pago pendiente en asistencia (tonos de alerta). */
export async function playAttendanceAlertSound() {
  try {
    await unlockAttendanceAudio();
    if (!sharedCtx) return;
    const ctx = sharedCtx;
    const playTone = (freq, start, duration, volume = 0.55) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "square";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(volume, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + duration);
    };
    const t0 = ctx.currentTime;
    for (let i = 0; i < 3; i += 1) {
      const base = t0 + i * 0.55;
      playTone(880, base, 0.18);
      playTone(660, base + 0.22, 0.18);
    }
  } catch {
    /* sin audio */
  }
}
